import React, { ReactElement } from "react";
import styles from "./styles.module.scss"
import { Box, Button, Typography } from "@mui/material";
import { Translate } from "react-redux-i18n";
import FontAwesomeIcon from "../FontAwesomeIcon";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { closeDialog } from "redux/dialog/dialogSlice";
import { cancelCouponRequested, showPlayedCouponDetails } from "redux/coupon/couponSlice";

export default function ConfirmCancel(): ReactElement {
  const dispatch = useAppDispatch()
  const cancelCouponId = useAppSelector(state => state.coupon.couponId)

  const handleCancel = () => {
    dispatch(closeDialog())
  }

  const handleProceed = () => {
    dispatch(cancelCouponRequested(cancelCouponId))
    dispatch(closeDialog())
    dispatch(showPlayedCouponDetails(false))
  }

  return (
    <Box className={styles.cancelConfirmContainer}>
      <Typography className={styles.cancelConfirmTitle}>
        <Translate value="coupon.cancelConfirm" />
      </Typography>
      <Box className={styles.buttonGroup}>
        <Button onClick={() => handleCancel()} variant="contained" color="error" className={styles.cancelButton}>
          <FontAwesomeIcon name="x" type="fas" /> &nbsp; &nbsp;<Translate value="coupon.cancel" />
        </Button>
        <Button onClick={() => handleProceed()} variant="contained" color="success" className={styles.proceedButton}>
          <FontAwesomeIcon name="check" type="fas" /> &nbsp; &nbsp;<Translate value="coupon.proceed" />
        </Button>
      </Box>
    </Box>
  )
}